import { render, staticRenderFns } from "./CustomerAddressViewPopup.vue?vue&type=template&id=1485308d&"
import script from "./CustomerAddressViewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressViewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports